// import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  // Handle Vue rendering errors (preferred approach according to docs)
  nuxtApp.hook("vue:error", (error, instance, info) => {
    console.error("Vue Error:", error, instance, info);

    if (import.meta.dev) {
      showError({
        message: "Wystąpił nieoczekiwany błąd w aplikacji",
      });
    }

    // Sentry.captureException(error);
  });

  // Handle startup errors (plugins, SSR, mounting)
  nuxtApp.hook("app:error", (error) => {
    console.error("App Startup Error:", error);

    const errorObj = error as { statusCode?: number; message?: string };

    if (import.meta.dev) {
      showError({
        statusCode: errorObj?.statusCode || 500,
        message: errorObj?.message || "Wystąpił błąd aplikacji",
      });
    }

    // Sentry.captureException(error);
  });
});
